"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toaster = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_1 = __importDefault(require("../../styles/styled"));
const theme_1 = __importDefault(require("../../styles/theme"));
const toast_1 = require("../toast/toast");
const TOAST_ANIMATION_SPEED = 300;
const Toaster = ({ content, onClose, onPauseToastTimeout, onResumeToastTimeout, }) => {
    const nodeRef = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsx)(ToasterWrapper, { children: content.map(toast => {
            return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, Object.assign({ nodeRef: nodeRef, timeout: TOAST_ANIMATION_SPEED - 10 }, { children: (0, jsx_runtime_1.jsx)(toast_1.Toast, Object.assign({ flavor: toast.flavor, onClose: () => onClose(toast.id), id: toast.id, onPauseToastTimeout: toast.manualClose ? null : () => onPauseToastTimeout(toast.id), onResumeToastTimeout: toast.manualClose
                        ? null
                        : () => onResumeToastTimeout(toast.id, toast === null || toast === void 0 ? void 0 : toast.timeout) }, { children: toast.content }), `toast-${toast.id}`) }), toast.id));
        }) }));
};
exports.Toaster = Toaster;
const ToasterWrapper = (0, styled_1.default)(react_transition_group_1.TransitionGroup)({
    display: 'grid',
    gridGap: '16px',
    position: 'fixed',
    bottom: '40px',
    right: '40px',
    zIndex: theme_1.default.layers.notification,
    '.enter': {
        animation: `${theme_1.default.keyframes.slideLeft} ${TOAST_ANIMATION_SPEED}ms linear infinite`,
        animationIterationCount: 1,
    },
    '.exit': {
        animation: `${theme_1.default.keyframes.slideLeft} ${TOAST_ANIMATION_SPEED}ms linear infinite`,
        animationIterationCount: 1,
        animationDirection: 'reverse',
    },
});
//# sourceMappingURL=toaster.js.map